import React, { useContext, useEffect, useRef, useState } from 'react';
import type { FormInstance } from 'dingtalk-design-desktop/es/form';
import { Form, Input, InputRef } from 'dingtalk-design-desktop';
import { keHuXinXi, jiuYeXinXi } from './locales';
import { json } from 'stream/consumers';

interface EditableRowProps {
    index: number;
}
interface EditableCellProps<T>{
    title: React.ReactNode;
    editable: boolean;
    children: React.ReactNode;
    dataIndex: keyof T;
    record: T;
    handleSave: (record:T, dataIndex:any) => void;
}

// 创建工厂函数
const createEditable = () => {
    //可编辑行
    const EditableContext = React.createContext<FormInstance<any> | null>(null);
    const row: React.FC<EditableRowProps> = ({ index, ...props }) => {
        const [form] = Form.useForm();
        return (
            <Form form={form} component={false}>
                <EditableContext.Provider value={form}>
                    <tr {...props} />
                </EditableContext.Provider>
            </Form>
        );
    };
    
    //可编辑单元格
    const cell: React.FC<EditableCellProps<keHuXinXi | jiuYeXinXi>> = ({
        title,
        editable,
        children,
        dataIndex,
        record,
        handleSave,
        ...restProps
    }) => {
        const [editing, setEditing] = useState(false);
        const inputRef = useRef<InputRef>(null);
        const form = useContext(EditableContext)!;
        
        //自动获得焦点
        useEffect(() => {
            if (editing) {
                inputRef.current!.focus();
            }
        }, [editing]);

        const toggleEdit = () => {
            setEditing(!editing);
            form.setFieldsValue({ [dataIndex]: record[dataIndex] });
        };

        const save = async () => {
            try {
                const values = await form.validateFields();
                toggleEdit();
                if (values[dataIndex] == "") {
                    form.setFieldsValue({ [dataIndex]: "-" });
                    let values_1 = { [dataIndex]: "-" }
                    handleSave({ ...record, ...values_1 }, dataIndex);
                } else {
                    handleSave({ ...record, ...values }, dataIndex);
                }
            } catch (errInfo) {
                console.log('Save failed:', errInfo);
            }
        };

        let childNode = children;

        if (editable) {
            childNode = editing ? (
                <Form.Item
                    style={{ margin: 0 }}
                    name={dataIndex}
                    rules={[
                        {
                            required: false,
                        }
                    ]}
                >
                    <Input ref={inputRef} onPressEnter={save} onBlur={save} />
                </Form.Item>
            ) : (
                <div className="editable-cell-value-wrap" onClick={toggleEdit}>
                    {children}
                </div>
            );
        }

        return <td {...restProps}>{childNode}</td>;
    };

    return {row:row,cell:cell};
};

// 创建组件
const Editable = createEditable();

export default Editable